import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "../../styles/PermissionButtonGroup.scss";

const PERMISSION_OPTIONS = [
    { label: "View-Only", value: "view", className: "view-only" },
    { label: "Edit", value: "edit", className: "edit" },
    { label: "Not Shared", value: "none", className: "not-shared" }
];

const PermissionButtonGroup = ({ criteriaKey, subject, onChange, initialValue }) => {
    const [selected, setSelected] = useState(initialValue);

    const handleSelect = (value) => {
        setSelected(value);
        onChange(criteriaKey, value);
    };

    useEffect(() => {
        setSelected(initialValue);
    }, [initialValue]);

    return (
        <div className="permission-group">
            <div className="subject-label">{subject}</div>
            <div className="button-set">
                {PERMISSION_OPTIONS.map((opt) => (
                    <button
                        key={opt.value}
                        className={`perm-btn ${opt.className} ${selected === opt.value ? "selected" : ""}`}
                        onClick={() => handleSelect(opt.value)}
                        type="button"
                    >
                        {opt.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

PermissionButtonGroup.propTypes = {
    criteriaKey: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    initialValue: PropTypes.oneOf(["view", "edit", "none"])
};

PermissionButtonGroup.defaultProps = {
    initialValue: "none"
};

export default PermissionButtonGroup;
